import { render } from "./sapConnection.vue?vue&type=template&id=b928d42a"
import script from "./sapConnection.vue?vue&type=script&lang=js"
export * from "./sapConnection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__